// src/components/LanguageSelector.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsDropdownOpen(false);
  };

  return (
    <div className="language-selector">
     
      {isDropdownOpen && (
        <div className="language-dropdown">
          <button onClick={() => changeLanguage('en')}>English</button>
          <button onClick={() => changeLanguage('es')}>Español</button>
          <button onClick={() => changeLanguage('fr')}>Français</button>
          <button onClick={() => changeLanguage('de')}>Deutsch</button>
          {/* Add more language options as needed */}
        </div>
        
      )}
       <button className="language-button" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        <img src="/images/language-change.png" alt="Change Language" className="language-icon" />
      </button>
    </div>
  );
};

export default LanguageSelector;
